module.exports = __webpack_public_path__ + "img/doc_editfilters.7ad8e7dc.gif";